/**
 * useCalendarEvents Hook
 * Fetches calendar meeting events for a given date range
 */
import { useQuery } from '@tanstack/react-query';
import calendarMeetingsService from '@services/domain/calendarMeetingsService';
import type { CalendarEventsResponse, CalendarEventsFilters } from '@app-types';

interface UseCalendarEventsOptions {
  filters: CalendarEventsFilters;
  enabled?: boolean;
}

export function useCalendarEvents({ filters, enabled = true }: UseCalendarEventsOptions) {
  return useQuery<CalendarEventsResponse>({
    queryKey: [
      'calendar-events',
      filters.startDate,
      filters.endDate,
      filters.includeCompleted,
      filters.division,
      filters.tier,
      filters.assessorId,
      filters.status,
    ],
    queryFn: () => calendarMeetingsService.getCalendarEvents(filters),
    staleTime: 5 * 60 * 1000,
    enabled,
  });
}
